import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from "react"
import { Input } from "@/src/components/ui/input"
import { Button } from "@/src/components/ui/button"
import { authClient } from "@/src/lib/auth-client"
import { useTranslation } from "@/src/i18n/client"

export const Route = createFileRoute('/_auth/forgot-password')({
  component: ForgotPasswordPage,
})

function ForgotPasswordPage() {
  const { t } = useTranslation('auth')
  const [email, setEmail] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")
    setSuccess(false)
    setIsLoading(true)
    
    try {
      const result = await authClient.requestPasswordReset({
        email,
        redirectTo: `${window.location.origin}/reset-password`,
      })
      
      if (result.error) {
        setError(result.error.message || t('forgotPassword.errorSendLink'))
      } else {
        setSuccess(true)
      }
    } catch (err) {
      setError(t('forgotPassword.errorSendLink'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <h2 className="mb-6 text-center text-2xl font-bold text-foreground">{t('forgotPassword.title')}</h2>
      {error && <div className="mb-4 text-red-500 text-center">{error}</div>}
      {success && <div className="mb-4 text-green-600 text-center">{t('forgotPassword.successMessage')}</div>}
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-foreground">{t('forgotPassword.email')}</label>
          <Input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="h-10 mt-1 block w-full rounded-md border border-input bg-background text-foreground shadow-sm focus:border-primary focus:ring-primary" />
        </div>
        <div>
          <Button type="submit" className="flex w-full justify-center bg-primary text-primary-foreground hover:bg-primary/90" disabled={isLoading}>
            {isLoading ? t('forgotPassword.sending') : t('forgotPassword.sendButton')}
          </Button>
        </div>
      </form>
      <p className="mt-4 text-center text-sm text-muted-foreground">
        {t('forgotPassword.remembered')} <Link to="/login" className="font-medium text-primary hover:text-primary/80">{t('forgotPassword.signIn')}</Link>
      </p>
    </div>
  )
}
